export var ResourceType;
(function (ResourceType) {
    ResourceType[ResourceType["TRANSLATION"] = 0] = "TRANSLATION";
})(ResourceType || (ResourceType = {}));
export var ResourceTag;
(function (ResourceTag) {
    ResourceTag["SDK"] = "sdk";
    ResourceTag["WEB"] = "web";
})(ResourceTag || (ResourceTag = {}));
export var ResourcePriority;
(function (ResourcePriority) {
    ResourcePriority[ResourcePriority["DefaultCommon"] = 50] = "DefaultCommon";
    ResourcePriority[ResourcePriority["Default"] = 100] = "Default";
    ResourcePriority[ResourcePriority["DefaultOverride"] = 200] = "DefaultOverride";
})(ResourcePriority || (ResourcePriority = {}));
export var StandardTranslationModuleName;
(function (StandardTranslationModuleName) {
    StandardTranslationModuleName["UXA"] = "uxa";
    StandardTranslationModuleName["COMMON"] = "common";
})(StandardTranslationModuleName || (StandardTranslationModuleName = {}));
export var TranslationProject;
(function (TranslationProject) {
    TranslationProject["UXA"] = "uxa";
})(TranslationProject || (TranslationProject = {}));
export const getCommonTranslationModuleForLocale = () => ({
    name: StandardTranslationModuleName.COMMON,
    priority: ResourcePriority.DefaultCommon,
    project: TranslationProject.UXA,
});
//# sourceMappingURL=resource.js.map